import { FILE_TYPES } from '@witmetrics/utils/constants';

export const FILE_TYPE_OPTIONS = Object.values(FILE_TYPES).map(
  ({ id, label }) => ({ value: id, label })
);
